import React from 'react'

// Libraries
import { Col, Container, Navbar, Row, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { AnimatePresence, m } from 'framer-motion'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Parallax } from "react-scroll-parallax";
import { Helmet } from "react-helmet";
import ButtonsVariant from '../Components/Button/ButtonVariant'; // Fixed: Use default import

// Components
import { fadeIn, fadeInLeft, zoomIn } from '../Functions/GlobalAnimations'
import IconWithText from '../Components/IconWithText/IconWithText'
import FooterStyle from '../Pages/Footer/Footer';
import ProcessStep from '../Components/ProcessStep/ProcessStep'
import TestimonialsCarousel09 from '../Components/TestimonialCarousel/TestimonialsCarousel09'
import Overlap from '../Components/Overlap/Overlap'
import InViewPort from "../Components/InViewPort";
import MainHeader from "../Pages/Header/MainHeader";
import HeaderForBus from "../Pages/Header/HeaderForBus";
import { IMAGE_PATHS } from '../Functions/Constant';
import { useNavigate } from "react-router-dom";
// Data
import { ProcessStepData01 } from '../Components/ProcessStep/ProcessStepData'
import { TestimonialsCarouselData9 } from '../Components/TestimonialCarousel/TestimonialsCarouselData'
import { IconWithTextData_09, ReviewsData } from '../Components/IconWithText/IconWithTextData'



const IconWithTextData = [
  {
    icon: "fas fa-user-check text-[40px]  yellow-class",
    title: "You Get Rated, Not Just Reviewed",
    content: "Be the first to build your career with verified ratings from real colleagues and employers.",
  },
  {
    icon: "solid-icon-File text-[40px]  yellow-class",
    title: "No More Traditional Resumes",
    content: "Show your true strengths through a smart profile powered by data, not just claims.",
  },
  {
    icon: "solid-icon-Globe text-[40px]  yellow-class",
    title: "Your Reputation Travels With You",
    content: "Take your ratings and profile wherever you go your career story stays yours.",
  },
  {
    icon: "solid-icon-Business-Man text-[40px]  yellow-class",
    title: "Smarter Hiring for Everyone",
    content: "Help employers make better decisions with clear, structured performance insights.",
  }
]

const jobcritic_usertype = localStorage.getItem("jobcritic_usertype");
const Home = (props) => {
  const navigate = useNavigate();
  const handleReviewClick = () => {
    const jwtTokenJobcritic = localStorage.getItem("jwt_token_jobcritic"); // Check user_id in localStorage
    if (jwtTokenJobcritic) {
      if (jobcritic_usertype == 2) {
        navigate("/verifications");
      } else {
        navigate("/profile"); // If logged in, go to review form
      }
    } else {
      if (jobcritic_usertype == 2) {
        navigate("/business-login");
      } else {
        navigate("/login");  // If logged in, go to review form
      }
    }
  };
  return (
    <div style={props.style}>
      {/* <SideButtons /> */}
      {/* Header Start */}

      {jobcritic_usertype == 2 ? <HeaderForBus /> : <MainHeader />}
      {/* Header End */}

      {/* Section Start */}
      <Helmet>
        <meta property="og:title" content="JobCritics – The World’s First Professional Rating Platform" />
        {/* <meta
          name="description"
          content="JobCritics: World’s first platform for individual ratings. Build your reputation for free. Boost your career now!"
        /> */}
        <meta property="og:description" content="Get rated by the people you've actually worked with. Build your professional reputation with authentic reviews." />
        <meta property="og:image" content="https://jobcritics.com/assets/img/biar/home_og.webp" />
        <meta property="og:url" content="https://jobcritics.com" />
        <meta property="og:type" content="website" />


        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="JobCritics – The World’s First Professional Rating Platform" />
        <meta name="twitter:description" content="Get rated by the people you've actually worked with. Build your professional reputation with authentic reviews. No resumes, just real proof of work." />
        <meta name="twitter:image" content="https://jobcritics.com/assets/img/biar/home_og.webp" />
        <meta name="twitter:url" content="https://jobcritics.com" />


      </Helmet>
      {/* <section className="py-[160px] overflow-hidden cover-background sm:py-[80px]" style={{ backgroundImage: `url('${IMAGE_PATHS.FIRSTBG} ')` }}> */}
      <section className="py-[160px] sm:py-[80px] overflow-hidden startup-processstep" >
        <Container>
          <Row className="items-center justify-center">
            <Col xl={6} md={6} className="sm:mb-[40px] overflow-hidden xs:text-center">
              {/* <h2 className="heading-5 font-serif font-semibold  uppercase mb-[9px] black-class text-[22px]"> Build Your Professional Reputation!</h2> */}
              <h3 className="font-serif font-bold   mb-[35px] tracking-[-1px] text-black text-[56px] leading-[1.1]">World's First Professional Rating Platform!</h3>
              <p className="w-[90%] xs:w-[100%] text-lg mb-[35px] leading-[38px] xs:text-xmd black-class !text-[32px] xs:leading-[1.2]">Get rated by your work connections.</p>

              {/* <Button
                className="btn-explore-white btor"
                onClick={handleReviewClick}
              >
                Create Your Profile
              </Button> */}
              <ButtonsVariant
                href="#"
                ariaLabel="button"
                onClick={handleReviewClick}
                className="mx-[10px]"
                variant="blackToWhite"
                size="xl"
                title="Create Your Profile"
              />

            </Col>
            {/* <Col xl={6} md={6} className="text-right">
              <img width="583px" height="608px" className="inline-block xs:h-[350px]" src={IMAGE_PATHS.FIRST} alt="World's First Professional Rating Platform." />
            </Col> */}
            <m.div className=" col-lg-6 md:mt-[50px]" {...fadeInLeft}>
              <div className="-mr-[30vw] relative md:mr-0" >
                <img src={IMAGE_PATHS.homestartupbusinessprocess} width={1109} height={638} className="overflow-hidden" alt="World's First Professional Rating Platform." />
              </div>
            </m.div>
          </Row>
        </Container>
      </section>
      {/* Section End */}
      <Helmet>

        <meta
          name="description"
          content="JobCritics empowers you with verified reputations, easy hiring, anonymous reviews, and secure ratings. Join now!"
        />
      </Helmet>
      {/* Section Start */}
      <section className="pt-[25px] pb-[8%] border-b border-[#ededed] overflow-hidden sm:pt-[50px] sm:pb-32">
        <Container>
          <Row className="justify-center xs:mb-16">
            <Col lg={8} sm={8} className="text-center font-serif mb-[60px] md:mb-[35px] sm:mb-16 xs:mb-0">
              {/* <span className="font-semibold uppercase  yellow-class block tracking-[1px] mb-[20px] sm:mb-[10px]">Why Choose JobCritics? We Put You First</span> */}
              <h2 className="heading-5 mx-auto font-medium text-[#131312] w-[90%] xs:w-full">The Only Platform for Verified Reputations and Smarter Hiring</h2>
              {/* <span className="font-semibold   block tracking-[1px] mb-[20px] sm:mb-[10px]">We empower individuals and employers with a trusted, secure rating system.</span> */}
            </Col>
          </Row>
          <ProcessStep grid="row-cols-1 row-cols-sm-2 row-cols-lg-4 gap-y-20" theme="process-step-style-04" data={ProcessStepData01} animation={fadeIn} />
        </Container>
      </section>
      {/* Section End */}

      {/* Lazy Load HTML */}
      {/* <InViewPort> */}
        {/* Section Start */}
        <Helmet>
          <meta
            name="description"
            content="JobCritics: World’s first platform for innovative hiring tech, verified profiles, and AI insights. "
          />
        </Helmet>
        <section className="py-[130px] overflow-hidden lg:py-[90px] sm:py-[50px]">
          <Container>
            <Row className="items-center justify-center">
              <Col md={6} xs={10} className="text-center sm:mb-[30px]">
                <m.img width="446px" height="509px" className="md:pr-[30px] mx-auto" src={IMAGE_PATHS.FOURTH} alt="The World’s First Platform for Innovative Hiring Technology" {...{ ...fadeIn, transition: { delay: 0.2 } }} />
              </Col>
              <m.div className="col-10 col-xl-6 col-lg-6   col-md-6 ps-lg-0 text-left md:text-start sm:text-center" {...fadeIn}>
                {/* <span className="font-serif font-semibold  yellow-class tracking-[1px] inline-block uppercase mb-[20px] sm:mb-[10px]">What is JobCritics?</span> */}
                <h2 className="heading-5 font-serif font-medium text-[#131312] tracking-[-1.5px]" >The World’s First Platform for Innovative Hiring Technology</h2>
                {/* <span className="font-serif font-semibold   tracking-[1px] inline-block  mb-[20px] sm:mb-[10px]">The World’s First Platform for Innovative Hiring Technology</span> */}
                <p className="mb-[40px]">JobCritics is a professional reputation platform that transforms careers with innovative hiring technology. Individuals create verified profiles using real performance data from employers and colleagues. Employers get instant, one-click credential checks. With AI-powered insights and peer-reviewed ratings, JobCritics replaces traditional resumes with a smarter, more trusted way to hire and grow.</p>

                <ButtonsVariant
                  ariaLabel="button"
                  href="#"
                  className="mx-[10px]"
                  variant="whiteToBlack"
                  size="md"
                  title="Start Your Profile Now"
                  onClick={handleReviewClick}
                />

              </m.div>
            </Row>
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <Helmet>
          <meta
            name="description"
            content="JobCritics: Create a profile, get ratings, generate an AI report, and review others for better opportunities!"
          />
        </Helmet>
        <section className="h-[550px] lg:h-[500px] sm:h-auto py-[130px] overflow-hidden cover-background lg:py-[90px] sm:py-[50px] xs:h-[1240px] md:h-[731px]" style={{ backgroundImage: `url(${IMAGE_PATHS.SECONDBG}` }}>
          <Container>
            <Row className="items-center justify-between">
              <m.div className="col-xl-3 col-lg-4 text-left  md:mb-[40px]" {...{ ...fadeIn, transition: { delay: 0.2 } }}>
                {/* <span className="font-serif font-medium yellow-class tracking-[1px] inline-block uppercase mb-[10px] font-semibold">How It Works?</span> */}
                <h2 className="font-serif font-semibold text-gradient bg-gradient-to-r from-[#131312] via-[#131312] to-[#131312] mb-0 text-[37px] md:text-[25px] lg:text-[40px] leading-[1.2]  md:text-center xs:text-center">
                  More<br />Reviews,<br /> More<br />Opportunities.
                </h2>
                {/* <span className="font-serif font-semibold   tracking-[1px] inline-block mb-[20px] sm:mb-[10px]">More Reviews,<br /> More Opportunities</span> */}

              </m.div>
              <Col lg={9} className="text-center">
                <IconWithText grid="row-cols-1 row-cols-md-4 row-cols-sm-2 items-center" theme="icon-with-text-09" data={IconWithTextData_09} animation={fadeIn}  />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <Helmet>
          <meta
            name="description"
            content="JobCritics: Build your career with verified ratings, smart profiles, portable reputation, and better hiring. Start now!"
          />
        </Helmet>
        <section className="py-[130px] overflow-hidden lg:py-[90px] md:pb-[120px] sm:pt-0 sm:py-[50px] lg:pt-[20px]">
          <Container>
            <Row className="items-center justify-center mb-[90px] md:mb-0">
              <Col lg={6} md={10} className="text-left md:mb-[30px] order-2 order-lg-1">
                <m.img width="548px" height="471px" src={IMAGE_PATHS.SECOND} alt="World’s First Rating & Review Platform for Individuals" {...fadeIn} />
              </Col>
              <Col lg={{ span: 5, offset: 1 }} md={10} className="seoagency-iconwithtext order-1 order-lg-2">
                <h2 className="heading-5 font-serif font-medium text-[#131312] tracking-[-1.5px] mb-[5px] md:text-center sm:text-center xs:text-center">
                  World’s First Rating & Review Platform for Individuals
                </h2>
                <IconWithText
                  grid="row-cols-1 row-cols-lg-1"
                  theme="icon-with-text-01 m-0 py-[40px] border-b border-mediumgray last-of-type:border-0"
                  data={IconWithTextData}
                  animation={fadeInLeft}
                />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <section className="overflow-visible pb-[100px] cover-background sm:py-[50px]">
          <Container>
            <Row>
              <Overlap>
                <m.div className="bg-gradient-to-tr from-[#FFBF00] via-[#FFBF00] to-[#FFDF80] rounded-[5px] py-[55px] md:p-[40px] section-wrappers" {...fadeIn}>
                  <Row className="justify-center items-center">
                    <Col lg={7} className="md:mb-[30px]">
                      <h1 className="heading-4 font-serif font-medium  mb-0  md:text-center black-class">Build Your Reputation with Verified Ratings!</h1>
                    </Col>
                    <Col lg={3} sm={10} xs={12}>
                      <div className="elative subscribe-style-06 text-end md:!text-center sm:!text-center">

                        <ButtonsVariant
                          onClick={handleReviewClick}
                          ariaLabel="button"
                          href="#"
                          className="mx-[10px]"
                          variant="whiteToBlack"
                          size="lg"
                          title="Get Started"
                        />
                      </div>
                    </Col>
                  </Row>
                </m.div>
              </Overlap>
            </Row>
            <Row className="justify-center mt-40">
              <Col xl={6} lg={7} md={8} className="relative">
                <TestimonialsCarousel09
                  data={TestimonialsCarouselData9}
                  animation={fadeIn}
                  carouselOption={{
                    slidesPerView: 1,
                    loop: true,
                    navigation: true
                  }}
                />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Section End */}
        {/* Section Start */}
        <Helmet>
          <meta
            name="description"
            content="JobCritics: Transform hiring with verified reviews, easy checks, and instant insights. Start smarter now!"
          />
        </Helmet>
        <section className="bg-lightgray py-[130px] lg:py-[90px] md:py-[75px] xs:py-[50px]">
          <Container>
            <Row className="justify-center flex">
              <m.div className="text-center mb-20 md:mb-12 col-lg-6 col-sm-8" {...fadeIn}>
                {/* <span className="text-xmd mb-[15px] font-serif block w-full yellow-class font-semibold">Transform Your Hiring Process</span> */}
                <h5 className="font-serif text-darkgray font-medium mb-8 sm:w-full text-[36px]">Hire Smarter, Faster, and with Confidence</h5>
              </m.div>
              <Col xs={12} md={9} lg={12}>
                <IconWithText
                  grid="row-cols-1 row-cols-md-1 row-cols-lg-2 gap-y-[15px]"
                  theme="icon-with-text-02 about-us-icon-with-text hove-cls"
                  data={ReviewsData}
                  animation={fadeIn}
                />
              </Col>
            </Row>
          </Container>
        </section >
        {/* Section End */}

        <m.section className="py-[40px] pb-[120px] lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px] overflow-hidden bg-lightgray" {...fadeIn}>
          <Container>
            <Row className="justify-center text-center font-serif font-medium text-darkgray">
              <Col xl={12} lg={8} md={10}>
                <h2 className="-tracking-[2px] mb-[50px] md:mb-[40px] xs:w-[98%] xs:mx-auto">Start Hiring Smart Hiring!</h2>
                <ButtonsVariant
                  onClick={handleReviewClick}
                  ariaLabel="button"
                  href="#"
                  className="mx-[10px]"
                  variant="whiteToBlack"
                  size="lg"
                  title="Get Started"
                />
              </Col>
            </Row>
          </Container>
        </m.section>


        {/* Section End */}

        {/* Section Start */}
        <FooterStyle theme="light" className="bg-black text-[#828282] seo-agency-footer_06" />
        {/* Section End */}
      {/* </InViewPort> */}
    </div>
  )
}

export default Home
